module.exports = __webpack_public_path__ + "static/edge-broucher-f3770007c00241807c253e404d79a6dc.pdf";